// @flow

import { type IncomingPayment } from './types';

export function getRecaptchaSiteKey(incomingPayment: IncomingPayment): ?string {
  return incomingPayment['recaptcha_site_key'];
}
